import { Component } from 'react';
import PropTypes from 'prop-types';

class WidgetHeader extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="widget-header">
        <div className="flex align-center justify-space-between">
          <div className="title">{this.props.title}</div>
          <div className="summary-count">{this.props.summaryCount}</div>
        </div>
        <div className="doc-count">{this.props.docCount}</div>
        <p
          className="subtitle"
          {...(this.props.shouldNotTranslateSubtitle || false ? { 'data-notranslate': true } : {})}
        >
          {this.props.subtitle}
        </p>
      </div>
    );
  }
}

export default WidgetHeader;
